import IcapImg from "./assests/icap.png";
import TapImg from "./assests/tap.png";
import FileShareImg from "./assests/fileshare.png";
import BulkScanImg from "./assests/bulkscan.png";
import ImapImg from "./assests/imap.png";
import PostfixImg from "./assests/postfix.png";
import SharePointImg from "./assests/sharepoint.png";
import UsbImg from "./assests/usb.png";
import CStrikeImg from "./assests/cstrike.png";
import DefenderImg from "./assests/defender.png";
import BroadcomCASImg from "./assests/broadcomcas.png";
import GoogleSecOpsImg from "./assests/googlesecopss.png";
import CortexXSOARImg from "./assests/cortexsoar.png";
import SumoLogicImg from "./assests/sumologic.png";
import OpswatMetadefenderImg from "./assests/opswatmetadefender.png";
import ThreatQImg from "./assests/threatq.png";
import { parseMount } from "../../Components/PagesComponents/IntegrationsMarket/shareMount";

export const CARD_DATA = [
  {
    intname: "imapemail",
    cardName: "Imap Email",
    messageonly: 0,
    cardDescription:
      "Imap Email integration scans incoming emails and automatically sends the attachments to CyberFortress SBOX for security analysis.",
    imgSrc: ImapImg,
    imgClassName: "integration-market__images imap",
    listPopup: {
      titles: [
        { title: "User", data: "username", width: "20%" },
        { title: "Server", data: "server", width: "30%" },
        { title: "Path", data: "authority", width: "40%" },
      ],
      trashButton: { enabled: true },
      mountPoint: "authority",
    },
  },
  {
    intname: "postfixemail",
    cardName: "Postfix Email",
    messageonly: 0,
    cardDescription:
      "Postfix Email integration scans incoming emails to the smtp port and automatically sends the attachments to CyberFortress SBOX for security analysis.",
    imgSrc: PostfixImg,
    imgClassName: "integration-market__images postfix",
  },
  {
    intname: "rclshare",
    cardName: "Sharepoint",
    cardDescription:
      "SharePoint integration enhances file sharing security in Microsoft's cloud-based storage platforms through CyberFortress SBOX.",
    imgSrc: SharePointImg,
    imgClassName: "integration-market__images sharepoint",
    listPopup: {
      titles: [
        {
          title: "Type",
          data: (conf) => (conf.type === "sharepoint-onprem" ? "On-Prem" : "Online"),
          width: "20%",
        },
        { title: "Server", data: "server", width: "30%" },
        { title: "Authority", data: "authority", width: "40%" },
      ],
      trashButton: { enabled: true },
      mountPoint: "authority",
    },
  },
  {
    intname: "winshare",
    cardName: "File Share",
    messageonly: 0,
    cardDescription:
      "The File Share integration allows CyberFortress SBOX to scan the traffic that takes place in various other party file sharing locations.",
    imgSrc: FileShareImg,
    imgClassName: "integration-market__images",
    listPopup: {
      titles: [
        {
          title: "User",
          data: (conf) => {
            const username = conf.mountparams?.split(",").reduce((obj, item) => {
              const [key, value] = item.split("=");
              obj[key] = value;
              return obj;
            }, {})?.username;

            return username;
          },
          width: "20%",
        },
        {
          title: "Server",
          data: (conf) => parseMount(conf || {}).ip,
          width: "30%",
        },
        {
          title: "Path",
          data: (conf) => parseMount(conf || {}).path,
          width: "40%",
        },
      ],
      trashButton: { enabled: true },
      mountPoint: "mountpoint",
    },
  },
  {
    intname: "bulkscan",
    cardName: "Bulk Scan",
    messageonly: 0,
    cardDescription:
      "The Bulk Scan integration allows CyberFortress SBOX to scan the traffic that takes place in various other party file sharing locations.",
    imgSrc: BulkScanImg,
    imgClassName: "integration-market__images",
    listPopup: {
      titles: [
        {
          title: "User",
          data: (conf) => {
            const username = conf.mountparams?.split(",").reduce((obj, item) => {
              const [key, value] = item.split("=");
              obj[key] = value;
              return obj;
            }, {})?.username;

            return username;
          },
          width: "20%",
        },
        {
          title: "Server",
          data: (conf) => parseMount(conf || {}).ip,
          width: "30%",
        },
        {
          title: "Path",
          data: (conf) => parseMount(conf || {}).path,
          width: "40%",
        },
      ],
      trashButton: { enabled: true },
      mountPoint: "mountpoint",
    },
  },
  {
    intname: "icapweb",
    cardName: "ICAP Proxy",
    cardDescription:
      "ICAP Proxy integration aims to protect users from malicious content within web proxy communications by analyzing it through CyberFortress SBOX.",
    imgSrc: IcapImg,
    imgClassName: "integration-market__images icap",
  },
  {
    intname: "tapweb",
    cardName: "Tap Interface",
    messageonly: 0,
    cardDescription:
      "TAP Interface integration allows for the analysis of network traffic through CyberFortress SBOX.",
    imgSrc: TapImg,
    imgClassName: "integration-market__images tap",
    listPopup: {
      titles: [
        {
          title: "Bulk",
          data: "bulk",
          width: "10%",
        },
        {
          title: "Type",
          data: "type",
          width: "25%",
        },
        {
          title: "Interface",
          data: "interface",
          width: "45%",
        },
        {
          title: "Interval",
          data: "interval",
          width: "10%",
        },
      ],
      trashButton: { enabled: true },
      mountPoint: "interface",
    },
  },
  {
    intname: "cstrike",
    cardName: "CS Falcon",
    messageonly: 0,
    cardDescription:
      "The EDR API integration enhances the security of files flagged by EDR systems by automatically analyzing those that are identified as malicious or suspicious.",
    imgSrc: CStrikeImg,
    imgClassName: "integration-market__images",
    listPopup: {
      titles: [
        { title: "Client ID", data: "client_id", text: "Client ID", width: "40%" },
        { title: "Secret", data: "secret", width: "50%" },
      ],
      trashButton: { enabled: true },
      mountPoint: "client_id",
    },
  },
  {
    intname: "defender",
    cardName: "MS Defender",
    messageonly: 0,
    cardDescription:
      "The Microsoft Defender integration enhances the security of endpoint devices by analyzing files that Windows Defender flags as potentially malicious.",
    imgSrc: DefenderImg,
    imgClassName: "integration-market__images",
    listPopup: {
      titles: [
        { title: "Tenant ID", data: "tenant_id", width: "30%" },
        { title: "App ID", data: "app_id", width: "30%" },
        { title: "Secret", data: "secret", width: "30%" },
      ],
      trashButton: { enabled: true },
      mountPoint: "app_id",
    },
  },
  {
    intname: "usbtransfer",
    cardName: "USB Transfer",
    cardDescription:
      "The USB Transfer integration secures data transfers conducted through USB using CyberFortress SBOX.",
    imgSrc: UsbImg,
    imgClassName: "integration-market__images usb",
    messageonly: 1,
  },
  {
    intname: "broadcomcas",
    cardName: "Broadcom CAS",
    messageonly: 1,
    cardDescription:
      "Broadcom Content Analysis System integration enables automatic forwarding of suspicious files from Broadcom CAS to CyberFortress SBOX as an external analysis engine.",
    imgSrc: BroadcomCASImg,
    imgClassName: "integration-market__images",
  },
  {
    intname: "googlesecopss",
    cardName: "Google Security Operations",
    messageonly: 1,
    cardDescription:
      "Google Security Operations integration enables Chronicle SIEM/SOAR playbooks to automatically submit suspicious samples to CyberFortress SBOX during threat investigations.",
    imgSrc: GoogleSecOpsImg,
    imgClassName: "integration-market__images",
  },
  {
    intname: "cortexsoar",
    cardName: "Cortex XSOAR",
    messageonly: 1,
    cardDescription:
      "Cortex XSOAR integration embeds CyberFortress SBOX as a sandbox analysis engine within XSOAR playbooks for automated file inspection during incident response.",
    imgSrc: CortexXSOARImg,
    imgClassName: "integration-market__images",
  },
  {
    intname: "sumologic",
    cardName: "Sumo Logic",
    messageonly: 1,
    cardDescription:
      "Sumo Logic integration connects CyberFortress SBOX with Sumo Logic's security analytics platform to enrich threat investigations with automated sandbox analysis.",
    imgSrc: SumoLogicImg,
    imgClassName: "integration-market__images",
  },
  {
    intname: "opswatmetadefender",
    cardName: "OPSWAT MetaDefender",
    messageonly: 1,
    cardDescription:
      "OPSWAT MetaDefender NDR integration forwards suspicious network artifacts detected by MetaDefender directly to CyberFortress SBOX for in-depth sandbox analysis.",
    imgSrc: OpswatMetadefenderImg,
    imgClassName: "integration-market__images",
  },
  {
    intname: "threatq",
    cardName: "ThreatQ",
    messageonly: 1,
    cardDescription:
      "ThreatQ Platform integration submits suspicious files and IOCs from ThreatQ's threat intelligence workflows to CyberFortress SBOX, enriching analysis results back into the platform.",
    imgSrc: ThreatQImg,
    imgClassName: "integration-market__images",
  },
];
